import React, { Component } from 'react';
import { withRouter } from 'react-router';
class Inputnormal extends Component {
  render() {
    const {title, group, checking, main} = this.props;
    return (
        <div>
          <label htmlFor={group} className={`input-label-checkbox-normal ${checking === group ? 'label-click': ''} ${main === 'LR' ? 'label-lr': ''} ${main === 'abdadd' ? 'label-abdadd': ''} ${main === 'button' ? 'main-buttons-label' : ''}`}>{title}</label>
          <input type="checkbox" name={group} value={group} className="user-inputs user-inputs-radio" id={group} onClick={this.props.click}/>
        </div>
    );
  }
}

export default withRouter(Inputnormal);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Inputnormal.js